try {
  // Define DetailsDisclosure only once and ensure it's globally available
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      try {
        this.mainDetailsToggle = this.querySelector('details');
        // Any additional initialization code
      } catch (error) {
        console.error('Error initializing DetailsDisclosure:', error);
      }
    }

    // Any additional methods for DetailsDisclosure
  }

  // Ensure that DetailsDisclosure is defined as a custom element
  if (!customElements.get('details-disclosure')) {
    customElements.define('details-disclosure', DetailsDisclosure);
  }

  // Define ShareButton only once
  if (!customElements.get('share-button')) {
    customElements.define(
      'share-button',
      class ShareButton extends DetailsDisclosure {
        constructor() {
          super();

          try {
            this.elements = {
              shareButton: this.querySelector('button'),
              shareSummary: this.querySelector('summary'),
              closeButton: this.querySelector('.share-button__close'),
              successMessage: this.querySelector('[id^="ShareMessage"]'),
              urlInput: this.querySelector('input'),
            };
            this.urlToShare = this.elements.urlInput
              ? this.elements.urlInput.value
              : document.location.href;

            if (navigator.share) {
              this.mainDetailsToggle.setAttribute('hidden', '');
              this.elements.shareButton.classList.remove('hidden');
              this.elements.shareButton.addEventListener('click', () => {
                try {
                  navigator.share({
                    url: this.urlToShare,
                    title: document.title,
                  });
                } catch (error) {
                  console.error('Error sharing:', error);
                }
              });
            } else {
              this.mainDetailsToggle.addEventListener(
                'toggle',
                this.toggleDetails.bind(this)
              );
              this.mainDetailsToggle
                .querySelector('.share-button__copy')
                .addEventListener(
                  'click',
                  this.copyToClipboard.bind(this)
                );
              this.mainDetailsToggle
                .querySelector('.share-button__close')
                .addEventListener('click', this.close.bind(this));
            }
          } catch (error) {
            console.error('Error initializing ShareButton:', error);
          }
        }

        toggleDetails() {
          try {
            if (!this.mainDetailsToggle.open) {
              this.elements.successMessage.classList.add('hidden');
              this.elements.successMessage.textContent = '';
              this.elements.closeButton.classList.add('hidden');
              this.elements.shareSummary.focus();
            }
          } catch (error) {
            console.error('Error toggling details:', error);
          }
        }

        copyToClipboard() {
          try {
            navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
              this.elements.successMessage.classList.remove('hidden');
              this.elements.successMessage.textContent =
                window.accessibilityStrings.shareSuccess;
              this.elements.closeButton.classList.remove('hidden');
              this.elements.closeButton.focus();
            });
          } catch (error) {
            console.error('Error copying to clipboard:', error);
          }
        }

        updateUrl(url) {
          try {
            this.urlToShare = url;
            this.elements.urlInput.value = url;
          } catch (error) {
            console.error('Error updating URL:', error);
          }
        }
      }
    );
  }
} catch (error) {
  console.error('An error occurred:', error);
}

// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     // Any additional initialization code
//   }

//   // Any additional methods for DetailsDisclosure
// }

// // Ensure that DetailsDisclosure is defined as a custom element
// if (!customElements.get('details-disclosure')) {
//   customElements.define('details-disclosure', DetailsDisclosure);
// }


// if (!customElements.get('share-button')) {
//   customElements.define(
//     'share-button',
//     class ShareButton extends DetailsDisclosure {
//       constructor() {
//         super();

//         this.elements = {
//           shareButton: this.querySelector('button'),
//           shareSummary: this.querySelector('summary'),
//           closeButton: this.querySelector('.share-button__close'),
//           successMessage: this.querySelector('[id^="ShareMessage"]'),
//           urlInput: this.querySelector('input'),
//         };
//         this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

//         if (navigator.share) {
//           this.mainDetailsToggle.setAttribute('hidden', '');
//           this.elements.shareButton.classList.remove('hidden');
//           this.elements.shareButton.addEventListener('click', () => {
//             navigator.share({ url: this.urlToShare, title: document.title });
//           });
//         } else {
//           this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
//           this.mainDetailsToggle
//             .querySelector('.share-button__copy')
//             .addEventListener('click', this.copyToClipboard.bind(this));
//           this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
//         }
//       }

//       toggleDetails() {
//         if (!this.mainDetailsToggle.open) {
//           this.elements.successMessage.classList.add('hidden');
//           this.elements.successMessage.textContent = '';
//           this.elements.closeButton.classList.add('hidden');
//           this.elements.shareSummary.focus();
//         }
//       }

//       copyToClipboard() {
//         navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
//           this.elements.successMessage.classList.remove('hidden');
//           this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
//           this.elements.closeButton.classList.remove('hidden');
//           this.elements.closeButton.focus();
//         });
//       }

//       updateUrl(url) {
//         this.urlToShare = url;
//         this.elements.urlInput.value = url;
//       }
//     }
//   );
// }
